
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import FormCheckLabel from './form-check-label'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formchecklabel"
    }}>{`FormCheckLabel`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "check-label"
    }}>{`Check label`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For a set of selectable values and used alongside `}<inlineCode parentName="p">{`<FormCheckbox />`}</inlineCode>{` or `}<inlineCode parentName="p">{`<FormRadioButton />`}</inlineCode>{`. In a group of checkbox inputs, multiple values may be selected.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={1} __code={'<FormCheckLabel>Input text</FormCheckLabel>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormCheckLabel
    }} mdxType="Playground">
    <FormCheckLabel mdxType="FormCheckLabel">Input text</FormCheckLabel>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <p>{`For a set of selectable values. In a group of checkbox inputs, multiple values may be selected.`}</p>
    <Playground __position={2} __code={'<FormCheckLabel isDisabled>Input text</FormCheckLabel>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormCheckLabel
    }} mdxType="Playground">
    <FormCheckLabel isDisabled mdxType="FormCheckLabel">Input text</FormCheckLabel>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormCheckLabel} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;